export const generalInformation = {
    "hiverChat": {
        inboxName : "Chat Inbox Name *",
        inboxPlaceHolder: "Enter your chat inbox name (eg: Live Chat)",
        usersText: "Users *",
        userDescription: "Add users who will be a part of this chat inbox",
        userDropDownPlaceHolder: "Select users to be added to the chat inbox.",
        nextAction: "chatWidget"
    },
    "whatsapp": {
        header: "General Information",
        inboxName : "WhatsApp Inbox name",
        inboxPlaceHolder: "Eg: WhatsApp inbox",
        usersText: "Users",
        userDescription: "Add users to this inbox",
        userDropDownPlaceHolder: "Select users to be added to the WhatsApp inbox.",
        nextAction: "connectNumber",
        subHeading: "Enter the inbox name here"
    }
}
